/**
 * Homepage content - Multilingual translations (EN/FR/ES/AR)
 */

export type SupportedLang = 'en' | 'fr' | 'es' | 'ar' | 'de' | 'it' | 'pt' | 'nl' | 'pl' | 'ru' | 'zh' | 'ja' | 'tr' | 'ko' | 'sv' | 'da' | 'hi' | 'ro' | 'cs' | 'hu' | 'fi' | 'th' | 'vi' | 'el' | 'no' | 'id' | 'ms' | 'tl' | 'bn';

export const homeContent = {
 hero: {
 en: {
 badge: 'Multilingual Contact Center & CX',
 h1: 'Multilingual BPO & Contact Center Outsourcing from Morocco',
 sub: 'Customer service, technical support & back-office for your customers.',
 ctaPrimary: 'Request a Quote',
 ctaSecondary: 'Contact Us',
 trustBadge: 'Multilingual teams • Data protection',
 microProof: [
 '24/7 coverage available on request',
 'Multilingual teams (EN/FR/ES/AR)',
 '',
 'Based in Casablanca, Morocco',
 'Data protection'
 ],
 proofMetrics: [
  { value: '', label: 'Languages', description: 'Multilingual teams available' },
  { value: '', label: 'Channels', description: 'Voice, chat, email, social' },
  { value: '', label: 'Nearshore', description: 'Based in Casablanca, Morocco' }
 ],
 trustedBy: 'Multilingual BPO • Casablanca, Morocco',
 dialogTitle: 'Schedule a Discovery Call',
 },
 fr: {
 badge: 'Centre de contact multilingue & CX',
 h1: 'Externalisation BPO et centre de contacts multilingue au Maroc',
 sub: 'Service client, support technique & back-office pour vos clients.',
 ctaPrimary: 'Demander un devis',
 ctaSecondary: 'Nous contacter',
 trustBadge: 'Équipes multilingues • Protection des données',
 microProof: [
 'Couverture 24/7 possible sur demande',
 'Équipes multilingues (FR/EN/ES/AR)',
 '',
 'Basé à Casablanca, Maroc',
 'Protection des données'
 ],
 proofMetrics: [
  { value: '', label: 'Langues', description: 'Équipes multilingues disponibles' },
  { value: '', label: 'Canaux', description: 'Voix, chat, email, réseaux sociaux' },
  { value: '', label: 'Nearshore', description: 'Basé à Casablanca, Maroc' }
 ],
 trustedBy: 'BPO multilingue • Casablanca, Maroc',
 dialogTitle: 'Planifier un appel de découverte',
 },
 es: {
 badge: 'Contact Center Multilingüe & CX',
 h1: 'Externalización BPO y contact center multilingüe desde Marruecos',
 sub: 'Atención al cliente, soporte técnico y back-office — en varios idiomas.',
 ctaPrimary: 'Solicitar presupuesto',
 ctaSecondary: 'Contáctenos',
 trustBadge: 'Equipos multilingües • Protección de datos',
 microProof: [
 'Cobertura 24/7 disponible a petición',
 'Equipos multilingües (ES/EN/FR/AR)',
 '',
 'Con sede en Casablanca, Marruecos',
 'Protección de datos'
 ],
 proofMetrics: [
  { value: '', label: 'Idiomas', description: 'Equipos multilingües disponibles' },
  { value: '', label: 'Canales', description: 'Voz, chat, email, redes sociales' },
  { value: '', label: 'Nearshore', description: 'Con sede en Casablanca, Marruecos' }
 ],
 trustedBy: 'BPO multilingüe • Casablanca, Marruecos',
 dialogTitle: 'Agenda una llamada de descubrimiento',
 },
 ar: {
 badge: 'مركز اتصال متعدد اللغات وتجربة العملاء',
 h1: 'مركز الاتصال متعدد اللغات الخاص بك',
 sub: 'خدمة العملاء والدعم الفني والمكتب الخلفي — بعدة لغات.',
 ctaPrimary: 'اطلب عرض سعر',
 ctaSecondary: 'تواصل معنا',
 trustBadge: 'فرق متعددة اللغات • حماية البيانات',
 microProof: [
 'تغطية 24/7 عند الطلب',
 'فرق متعددة اللغات (AR/FR/EN/ES)',
 '',
 'مقرنا الدار البيضاء، المغرب',
 'حماية البيانات'
 ],
 proofMetrics: [
  { value: '', label: 'لغات', description: 'فرق متعددة اللغات متاحة' },
  { value: '', label: 'قنوات', description: 'صوت، دردشة، بريد، شبكات اجتماعية' },
  { value: '', label: 'Nearshore', description: 'مقرنا الدار البيضاء، المغرب' }
 ],
 trustedBy: 'BPO متعدد اللغات • الدار البيضاء، المغرب',
 dialogTitle: 'جدولة مكالمة استكشافية',
 },
 de: {
 badge: 'Mehrsprachiges Contact Center & CX',
 h1: 'Ihr mehrsprachiges Contact Center',
 sub: 'Kundenservice, technischer Support & Backoffice — in mehreren Sprachen.',
 ctaPrimary: 'Angebot anfordern',
 ctaSecondary: 'Kontakt aufnehmen',
 trustBadge: 'Mehrsprachige Teams • Datenschutz',
 microProof: ['24/7-Abdeckung auf Anfrage', 'Mehrsprachige Teams (DE/EN/FR/ES)', '', 'Sitz in Casablanca, Marokko', 'Datenschutz'],
 proofMetrics: [{ value: '', label: 'Sprachen', description: 'Mehrsprachige Teams verfügbar' }, { value: '', label: 'Kanäle', description: 'Telefon, Chat, E-Mail, Social Media' }, { value: '', label: 'Nearshore', description: 'Sitz in Casablanca, Marokko' }],
 trustedBy: 'Mehrsprachiges BPO • Casablanca, Marokko',
 dialogTitle: 'Entdeckungsgespräch buchen',
 },
 it: {
 badge: 'Contact Center Multilingue & CX',
 h1: 'Il tuo contact center multilingue',
 sub: 'Servizio clienti, supporto tecnico e back-office — in più lingue.',
 ctaPrimary: 'Richiedi un preventivo',
 ctaSecondary: 'Contattaci',
 trustBadge: 'Team multilingue • Protezione dei dati',
 microProof: ['Copertura 24/7 su richiesta', 'Team multilingue (IT/EN/FR/ES)', '', 'Sede a Casablanca, Marocco', 'Protezione dei dati'],
 proofMetrics: [{ value: '', label: 'Lingue', description: 'Team multilingue disponibili' }, { value: '', label: 'Canali', description: 'Voce, chat, email, social' }, { value: '', label: 'Nearshore', description: 'Sede a Casablanca, Marocco' }],
 trustedBy: 'BPO multilingue • Casablanca, Marocco',
 dialogTitle: 'Prenota una chiamata esplorativa',
 },
 pt: {
 badge: 'Contact Center Multilíngue & CX',
 h1: 'Seu contact center multilíngue',
 sub: 'Atendimento ao cliente, suporte técnico e back-office para os seus clientes.',
 ctaPrimary: 'Pedir orçamento',
 ctaSecondary: 'Fale conosco',
 trustBadge: 'Equipes multilíngues • Proteção de dados',
 microProof: ['Cobertura 24/7 disponível mediante pedido', 'Equipes multilíngues (PT/EN/FR/ES)', '', 'Sede em Casablanca, Marrocos', 'Proteção de dados'],
 proofMetrics: [{ value: '', label: 'Idiomas', description: 'Equipes multilíngues disponíveis' }, { value: '', label: 'Canais', description: 'Voz, chat, email, redes sociais' }, { value: '', label: 'Nearshore', description: 'Sede em Casablanca, Marrocos' }],
 trustedBy: 'BPO multilíngue • Casablanca, Marrocos',
 dialogTitle: 'Agendar uma chamada de descoberta',
 },
 nl: {
 badge: 'Meertalig Contactcenter & CX',
 h1: 'Jouw meertalige contactcenter',
 sub: 'Klantenservice, technische support & back-office — in meerdere talen.',
 ctaPrimary: 'Offerte aanvragen',
 ctaSecondary: 'Neem contact op',
 trustBadge: 'Meertalige teams • AVG-gelijklopende werkwijzen',
 microProof: ['24/7-dekking op aanvraag', 'Meertalige teams (NL/EN/FR/ES)', '', 'Gevestigd in Casablanca, Marokko', 'AVG-gelijklopende werkwijzen'],
 proofMetrics: [{ value: '', label: 'Talen', description: 'Meertalige teams beschikbaar' }, { value: '', label: 'Kanalen', description: 'Telefoon, chat, email, social media' }, { value: '', label: 'Nearshore', description: 'Gevestigd in Casablanca, Marokko' }],
 trustedBy: 'Meertalig BPO • Casablanca, Marokko',
 dialogTitle: 'Ontdekkingsgesprek boeken',
 },
 pl: {
 badge: 'Wielojęzyczne Contact Center i CX',
 h1: 'Twoje wielojęzyczne contact center',
 sub: 'Obsługa klienta, wsparcie techniczne i back-office — w wielu językach.',
 ctaPrimary: 'Poproś o wycenę',
 ctaSecondary: 'Skontaktuj się',
 trustBadge: 'Wielojęzyczne zespoły • Praktyki zgodne z RODO',
 microProof: ['Obsługa 24/7 na życzenie', 'Wielojęzyczne zespoły (PL/EN/FR/ES)', '', 'Siedziba w Casablance, Maroko', 'Praktyki zgodne z RODO'],
 proofMetrics: [{ value: '', label: 'Języki', description: 'Wielojęzyczne zespoły dostępne' }, { value: '', label: 'Kanały', description: 'Głos, czat, email, social media' }, { value: '', label: 'Nearshore', description: 'Siedziba w Casablance, Maroko' }],
 trustedBy: 'Wielojęzyczne BPO • Casablanca, Maroko',
 dialogTitle: 'Zarezerwuj rozmowę odkrywczą',
 },
 ru: {
 badge: 'Многоязычный контакт-центр и CX',
 h1: 'Ваш многоязычный контакт-центр',
 sub: 'Поддержка клиентов, техническая поддержка и бэк-офис — на нескольких языках.',
 ctaPrimary: 'Запросить расчёт',
 ctaSecondary: 'Свяжитесь с нами',
 trustBadge: 'Многоязычные команды • Защита данных',
 microProof: ['Покрытие 24/7 по запросу', 'Многоязычные команды (RU/EN/FR/ES)', '', 'Офис в Касабланке, Марокко', 'Защита данных'],
 proofMetrics: [{ value: '', label: 'Языки', description: 'Многоязычные команды' }, { value: '', label: 'Каналы', description: 'Голос, чат, email, соцсети' }, { value: '', label: 'Nearshore', description: 'Офис в Касабланке, Марокко' }],
 trustedBy: 'Многоязычный BPO • Касабланка, Марокко',
 dialogTitle: 'Запланировать ознакомительный звонок',
 },
 zh: {
 badge: '多语言联络中心与客户体验',
 h1: '您的多语言联络中心',
 sub: '为您的客户提供客户服务、技术支持与后台支持。',
 ctaPrimary: '获取报价',
 ctaSecondary: '联系我们',
 trustBadge: '多语言团队 • 数据保护',
 microProof: ['可应要求提供24/7覆盖', '多语言团队（中/英/法/西）', '', '总部位于摩洛哥卡萨布兰卡', '数据保护'],
 proofMetrics: [{ value: '', label: '语言', description: '多语言团队可用' }, { value: '', label: '渠道', description: '电话、在线聊天、邮件、社交媒体' }, { value: '', label: 'Nearshore', description: '总部位于摩洛哥卡萨布兰卡' }],
 trustedBy: '多语言BPO • 卡萨布兰卡，摩洛哥',
 dialogTitle: '预约探索性通话',
 },
 ja: {
 badge: '多言語コンタクトセンター & CX',
 h1: 'あなたの多言語コンタクトセンター',
 sub: 'カスタマーサービス、テクニカルサポート、バックオフィス — 複数言語で対応。',
 ctaPrimary: '見積もりを依頼',
 ctaSecondary: 'お問い合わせ',
 trustBadge: '多言語チーム • データ保護',
 microProof: ['24/7カバレッジはリクエスト制', '多言語チーム（日/英/仏/西）', '', 'カサブランカ（モロッコ）拠点', 'データ保護'],
 proofMetrics: [{ value: '', label: '言語', description: '多言語チーム対応可能' }, { value: '', label: 'チャネル', description: '電話、チャット、メール、SNS' }, { value: '', label: 'Nearshore', description: 'カサブランカ（モロッコ）拠点' }],
 trustedBy: '多言語BPO • カサブランカ、モロッコ',
 dialogTitle: 'ディスカバリーコールを予約',
 },
 tr: {
 badge: 'Çok Dilli İletişim Merkezi & CX',
 h1: 'Çok dilli iletişim merkeziniz',
 sub: 'Müşteri hizmetleri, teknik destek ve back-office — birden çok dilde.',
 ctaPrimary: 'Teklif iste',
 ctaSecondary: 'Bize ulaşın',
 trustBadge: 'Çok dilli ekipler • Veri koruma',
 microProof: ['İstek üzerine 24/7 kapsama', 'Çok dilli ekipler (TR/EN/FR/ES)', '', 'Kazablanka, Fas merkezli', 'Veri koruma'],
 proofMetrics: [{ value: '', label: 'Diller', description: 'Çok dilli ekipler mevcut' }, { value: '', label: 'Kanallar', description: 'Ses, chat, e-posta, sosyal medya' }, { value: '', label: 'Nearshore', description: 'Kazablanka, Fas merkezli' }],
 trustedBy: 'Çok dilli BPO • Kazablanka, Fas',
 dialogTitle: 'Keşif görüşmesi planla',
 },
 ko: {
 badge: '다국어 컨택센터 & CX',
 h1: '다국어 컨택센터',
 sub: '고객 서비스, 기술 지원 및 백오피스 — 여러 언어로 제공.',
 ctaPrimary: '견적 요청',
 ctaSecondary: '문의하기',
 trustBadge: '다국어 팀 • 데이터 보호',
 microProof: ['24/7 커버리지 요청 시 제공', '다국어 팀 (한/영/불/서)', '', '모로코 카사블랑카 본사', '데이터 보호'],
 proofMetrics: [{ value: '', label: '언어', description: '다국어 팀 운영' }, { value: '', label: '채널', description: '전화, 채팅, 이메일, 소셜' }, { value: '', label: 'Nearshore', description: '모로코 카사블랑카 본사' }],
 trustedBy: '다국어 BPO • 카사블랑카, 모로코',
 dialogTitle: '디스커버리 콜 예약',
 },
 sv: {
 badge: 'Flerspråkigt kontaktcenter & CX',
 h1: 'Ditt flerspråkiga kontaktcenter',
 sub: 'Kundtjänst, teknisk support & back office — på flera språk.',
 ctaPrimary: 'Begär offert',
 ctaSecondary: 'Kontakta oss',
 trustBadge: 'Flerspråkiga team • Dataskydd',
 microProof: ['24/7-täckning på begäran', 'Flerspråkiga team (SV/EN/FR/ES)', '', 'Säte i Casablanca, Marocko', 'Dataskydd'],
 proofMetrics: [{ value: '', label: 'Språk', description: 'Flerspråkiga team tillgängliga' }, { value: '', label: 'Kanaler', description: 'Röst, chatt, e-post, sociala medier' }, { value: '', label: 'Nearshore', description: 'Säte i Casablanca, Marocko' }],
 trustedBy: 'Flerspråkigt BPO • Casablanca, Marocko',
 dialogTitle: 'Boka ett upptäcktssamtal',
 },
 da: {
 badge: 'Flersproget kontaktcenter & CX',
 h1: 'Dit flersprogede kontaktcenter',
 sub: 'Kundeservice, teknisk support & back-office — på flere sprog.',
 ctaPrimary: 'Anmod om tilbud',
 ctaSecondary: 'Kontakt os',
 trustBadge: 'Flersprogede teams • Databeskyttelse',
 microProof: ['24/7-dækning efter anmodning', 'Flersprogede teams (DA/EN/FR/ES)', '', 'Hovedsæde i Casablanca, Marokko', 'Databeskyttelse'],
 proofMetrics: [{ value: '', label: 'Sprog', description: 'Flersprogede teams tilgængelige' }, { value: '', label: 'Kanaler', description: 'Telefon, chat, e-mail, sociale medier' }, { value: '', label: 'Nearshore', description: 'Hovedsæde i Casablanca, Marokko' }],
 trustedBy: 'Flersproget BPO • Casablanca, Marokko',
 dialogTitle: 'Book et opdagelsesopkald',
 },
 },

 twoPillars: {
 en: {
 title: 'Two Pillars.',
 titleAccent: 'One Partner.',
 subtitle: 'Choose the path that fits your needs—or combine both for a complete solution.',
 pillar1: {
 title: 'Premium BPO / Contact Center',
 text: 'Customer Support, Tele-sales, Back-office, and Content Moderation—built for SLA, quality, and scalability.',
 bullets: ['Customer Support', 'Tele-sales', 'Back-office', 'Content Moderation'],
 cta: 'Explore BPO Solutions',
 },
 pillar2: {
 title: 'Digital Factory & Web Agency',
 text: 'High-performance websites, apps, AI automation, and CRM/helpdesk integrations—built to convert and scale.',
 bullets: ['Websites', 'Apps', 'AI automations', 'CRM/Helpdesk integrations'],
 cta: 'Explore Digital Factory',
 },
 },
 fr: {
 title: 'Deux piliers.',
 titleAccent: 'Un partenaire.',
 subtitle: 'Choisissez la voie qui correspond à vos besoins—ou combinez les deux pour une solution complète.',
 pillar1: {
 title: 'BPO Premium / Centre de contact',
 text: 'Support, télévente, back-office et modération — orientés SLA, qualité et scalabilité.',
 bullets: ['Support Client', 'Télévente', 'Back-office', 'Modération'],
 cta: 'Découvrir nos solutions BPO',
 },
 pillar2: {
 title: 'Usine Numérique & Agence Web',
 text: 'Sites et apps haute performance, automatisations IA, intégrations CRM/helpdesk — pensés conversion et croissance.',
 bullets: ['Sites web', 'Applications', 'Automatisations IA', 'Intégrations CRM/Helpdesk'],
 cta: 'Découvrir l\'Usine Numérique',
 },
 },
 es: {
 title: 'Dos pilares.',
 titleAccent: 'Un socio.',
 subtitle: 'Elige el camino que se adapte a tus necesidades—o combina ambos para una solución completa.',
 pillar1: {
 title: 'BPO Premium / Contact Center',
 text: 'Soporte, televentas, back-office y moderación — enfocado en SLA, calidad y escalabilidad.',
 bullets: ['Soporte al Cliente', 'Televentas', 'Back-office', 'Moderación'],
 cta: 'Ver soluciones BPO',
 },
 pillar2: {
 title: 'Digital Factory & Agencia Web',
 text: 'Webs y apps de alto rendimiento, automatización IA e integraciones CRM/helpdesk — para convertir y escalar.',
 bullets: ['Sitios web', 'Aplicaciones', 'Automatizaciones IA', 'Integraciones CRM/Helpdesk'],
 cta: 'Ver Digital Factory',
 },
 },
 ar: {
 title: 'ركيزتان.',
 titleAccent: 'شريك واحد.',
 subtitle: 'اختر المسار المناسب لاحتياجاتك — أو ادمج كليهما للحصول على حل متكامل.',
 pillar1: {
 title: 'BPO فاخر / مركز اتصال',
 text: 'دعم العملاء، مبيعات هاتفية، Back-office، ومراقبة محتوى — بجودة عالية وSLA صارم.',
 bullets: ['دعم العملاء', 'المبيعات الهاتفية', 'Back-office', 'مراقبة المحتوى'],
 cta: 'اكتشف حلول BPO',
 },
 pillar2: {
 title: 'Digital Factory & وكالة ويب',
 text: 'مواقع وتطبيقات عالية الأداء، أتمتة بالذكاء الاصطناعي، وتكاملات CRM/Helpdesk — لتحقيق تحويل أعلى ونمو أسرع.',
 bullets: ['مواقع ويب', 'تطبيقات', 'أتمتة بالذكاء الاصطناعي', 'تكاملات CRM/Helpdesk'],
 cta: 'اكتشف Digital Factory',
 },
 },
 },

 pilot: {
 en: {
 title: 'Launch a Pilot in',
 titleAccent: '7 Days',
 subtitle: 'Test our service with real tickets, real agents, and real KPIs—before you commit.',
 bullets: [
 'Scope + rollout plan in 24–48h',
 'Dedicated multilingual team setup',
 'KPI dashboard + weekly action plan'
 ],
 cta: 'Start the Pilot',
 note: 'No commitment required. See results first.',
 dialogTitle: 'Start Your 7-Day Pilot',
 },
 fr: {
 title: 'Lancer un pilote en',
 titleAccent: '7 jours',
 subtitle: 'Testez notre service avec de vrais tickets, de vrais agents et de vrais KPI — avant de vous engager.',
 bullets: [
 'Cadrage + plan de déploiement en 24–48h',
 'Mise en place d\'une équipe multilingue dédiée',
 'Dashboard KPI + plan d\'actions hebdo'
 ],
 cta: 'Démarrer le pilote',
 note: 'Aucun engagement requis. Voyez les résultats d\'abord.',
 dialogTitle: 'Démarrer votre pilote de 7 jours',
 },
 es: {
 title: 'Lanza un Piloto en',
 titleAccent: '7 Días',
 subtitle: 'Prueba nuestro servicio con tickets reales, agentes reales y KPIs reales — antes de comprometerte.',
 bullets: [
 'Alcance + plan en 24–48h',
 'Equipo multilingüe dedicado',
 'Dashboard KPI + plan semanal'
 ],
 cta: 'Empezar Piloto',
 note: 'Sin compromiso. Ve los resultados primero.',
 dialogTitle: 'Empieza tu Piloto de 7 días',
 },
 ar: {
 title: 'ابدأ تجربة خلال',
 titleAccent: '7 أيام',
 subtitle: 'اختبر خدمتنا بتذاكر حقيقية، ووكلاء حقيقيين، ومؤشرات أداء حقيقية — قبل الالتزام.',
 bullets: [
 'تحديد النطاق وخطة التنفيذ خلال 48 ساعة',
 'فريق متعدد اللغات مخصص',
 'لوحة مؤشرات KPI + خطة أسبوعية'
 ],
 cta: 'ابدأ التجربة',
 note: 'لا التزام مطلوب. شاهد النتائج أولاً.',
 dialogTitle: 'ابدأ تجربتك لمدة 7 أيام',
 },
 },

 services: {
 en: {
 badge: 'Our Services',
 title: 'Outcomes-Driven Solutions',
 subtitle: 'Every service is designed to deliver measurable results. Real KPIs, real impact.',
 viewAll: 'View All Services',
 viewService: 'View Service',
 items: [
 {
 title: 'Customer Support',
 outcome: 'Faster response, higher CSAT, multilingual coverage.',
 deliverables: ['Tier 1-3 multichannel support (voice, email, chat)', 'Ticket routing & escalation protocols', 'Knowledge base maintenance & macros'],
 kpis: 'CSAT, FRT, FCR',
 },
 {
 title: 'Tele-Sales',
 outcome: 'More qualified leads, higher conversion, predictable pipeline.',
 deliverables: ['Outbound campaigns & cold calling', 'Lead qualification & appointment setting', 'CRM updates & pipeline management'],
 kpis: 'Conversion rate, AOV, Lead-to-close',
 },
 {
 title: 'Back-Office',
 outcome: 'Accurate processing, strict SLA, scalable operations.',
 deliverables: ['Data entry & document processing', 'Order management & fulfillment', 'Invoice & payment reconciliation'],
 kpis: 'Accuracy, SLA, Throughput',
 },
 {
 title: 'Content Moderation',
 outcome: 'Fast TAT, consistent policies, safe user experience.',
 deliverables: ['User-generated content review', 'Trust & safety enforcement', 'Escalation & appeals handling'],
 kpis: 'TAT, Accuracy, Escalation rate',
 },
 {
 title: 'Web Development',
 outcome: 'Premium UI, SEO-ready, conversion-first builds.',
 deliverables: ['Custom web apps & landing pages', 'E-commerce & marketplace platforms', 'CMS & admin dashboard development'],
 kpis: 'Lighthouse score, SEO indexation, Conversion',
 },
 {
 title: 'Mobile Apps',
 outcome: 'Stable releases, clean UX, measurable retention.',
 deliverables: ['iOS & Android native/cross-platform apps', 'UI/UX design & prototyping', 'App store optimization & deployment'],
 kpis: 'Retention, Crash-free sessions, Time-to-release',
 },
 {
 title: 'AI Solutions',
 outcome: 'Automation, deflection, and cost-to-serve reduction.',
 deliverables: ['Chatbots & virtual agents', 'Workflow automation & RPA', 'Predictive analytics & ML models'],
 kpis: 'Automation rate, Deflection, Cost-to-serve',
 }
 ],
 },
 fr: {
 badge: 'Nos Services',
 title: 'Solutions Orientées Résultats',
 subtitle: 'Chaque service est conçu pour livrer des résultats mesurables. De vrais KPIs, un vrai impact.',
 viewAll: 'Voir tous les services',
 viewService: 'Voir le service',
 items: [
 {
 title: 'Support Client',
 outcome: 'Réponse plus rapide, CSAT plus élevé, couverture multilingue.',
 deliverables: ['Support multicanal Tier 1-3 (voix, email, chat)', 'Routage et protocoles d\'escalade', 'Maintenance base de connaissances & macros'],
 kpis: 'CSAT, FRT, FCR',
 },
 {
 title: 'Télévente',
 outcome: 'Plus de leads qualifiés, meilleure conversion, pipeline prévisible.',
 deliverables: ['Campagnes sortantes & cold calling', 'Qualification leads & prise de RDV', 'Mises à jour CRM & gestion pipeline'],
 kpis: 'Taux de conversion, AOV, Lead-to-close',
 },
 {
 title: 'Back-Office',
 outcome: 'Traitement précis, SLA strict, opérations scalables.',
 deliverables: ['Saisie de données & traitement documents', 'Gestion commandes & fulfillment', 'Rapprochement factures & paiements'],
 kpis: 'Précision, SLA, Débit',
 },
 {
 title: 'Modération de Contenu',
 outcome: 'TAT rapide, politiques cohérentes, expérience utilisateur sûre.',
 deliverables: ['Revue contenu généré utilisateur', 'Application trust & safety', 'Gestion escalades & appels'],
 kpis: 'TAT, Précision, Taux escalade',
 },
 {
 title: 'Développement Web',
 outcome: 'UI premium, SEO-ready, builds axés conversion.',
 deliverables: ['Apps web & landing pages sur mesure', 'Plateformes e-commerce & marketplace', 'Développement CMS & dashboard admin'],
 kpis: 'Score Lighthouse, Indexation SEO, Conversion',
 },
 {
 title: 'Applications Mobiles',
 outcome: 'Versions stables, UX épurée, rétention mesurable.',
 deliverables: ['Apps iOS & Android native/cross-platform', 'Design UI/UX & prototypage', 'Optimisation app store & déploiement'],
 kpis: 'Rétention, Sessions sans crash, Time-to-release',
 },
 {
 title: 'Solutions IA',
 outcome: 'Automatisation, déflection, réduction cost-to-serve.',
 deliverables: ['Chatbots & agents virtuels', 'Automatisation workflow & RPA', 'Analytics prédictive & modèles ML'],
 kpis: 'Taux automation, Déflection, Cost-to-serve',
 }
 ],
 },
 es: {
 badge: 'Nuestros Servicios',
 title: 'Soluciones Orientadas a Resultados',
 subtitle: 'Cada servicio está diseñado para entregar resultados medibles. KPIs reales, impacto real.',
 viewAll: 'Ver todos los servicios',
 viewService: 'Ver servicio',
 items: [
 {
 title: 'Soporte al Cliente',
 outcome: 'Respuesta más rápida, mayor CSAT, cobertura multilingüe.',
 deliverables: ['Soporte multicanal Tier 1-3 (voz, email, chat)', 'Enrutamiento y protocolos de escalado', 'Mantenimiento base conocimiento & macros'],
 kpis: 'CSAT, FRT, FCR',
 },
 {
 title: 'Televentas',
 outcome: 'Más leads cualificados, mayor conversión, pipeline predecible.',
 deliverables: ['Campañas outbound & cold calling', 'Cualificación leads & agenda citas', 'Actualizaciones CRM & gestión pipeline'],
 kpis: 'Tasa de conversión, AOV, Lead-to-close',
 },
 {
 title: 'Back-Office',
 outcome: 'Procesamiento preciso, SLA estricto, operaciones escalables.',
 deliverables: ['Entrada de datos & procesamiento documentos', 'Gestión pedidos & fulfillment', 'Conciliación facturas & pagos'],
 kpis: 'Precisión, SLA, Rendimiento',
 },
 {
 title: 'Moderación de Contenido',
 outcome: 'TAT rápido, políticas consistentes, experiencia de usuario segura.',
 deliverables: ['Revisión contenido generado por usuario', 'Aplicación trust & safety', 'Gestión escalados & apelaciones'],
 kpis: 'TAT, Precisión, Tasa escalado',
 },
 {
 title: 'Desarrollo Web',
 outcome: 'UI premium, SEO-ready, builds enfocados en conversión.',
 deliverables: ['Apps web & landing pages a medida', 'Plataformas e-commerce & marketplace', 'Desarrollo CMS & dashboard admin'],
 kpis: 'Score Lighthouse, Indexación SEO, Conversión',
 },
 {
 title: 'Apps Móviles',
 outcome: 'Versiones estables, UX limpia, retención medible.',
 deliverables: ['Apps iOS & Android nativas/multiplataforma', 'Diseño UI/UX & prototipado', 'Optimización app store & despliegue'],
 kpis: 'Retención, Sesiones sin crash, Time-to-release',
 },
 {
 title: 'Soluciones IA',
 outcome: 'Automatización, deflexión, reducción cost-to-serve.',
 deliverables: ['Chatbots & agentes virtuales', 'Automatización workflow & RPA', 'Analítica predictiva & modelos ML'],
 kpis: 'Tasa automatización, Deflexión, Cost-to-serve',
 }
 ],
 },
 ar: {
 badge: 'خدماتنا',
 title: 'حلول موجهة للنتائج',
 subtitle: 'كل خدمة مصممة لتقديم نتائج قابلة للقياس. مؤشرات أداء حقيقية، تأثير حقيقي.',
 viewAll: 'عرض جميع الخدمات',
 viewService: 'عرض الخدمة',
 items: [
 {
 title: 'دعم العملاء',
 outcome: 'استجابة أسرع، CSAT أعلى، تغطية متعددة اللغات.',
 deliverables: ['دعم متعدد القنوات Tier 1-3 (صوت، بريد، دردشة)', 'توجيه التذاكر وبروتوكولات التصعيد', 'صيانة قاعدة المعرفة والماكرو'],
 kpis: 'CSAT, FRT, FCR',
 },
 {
 title: 'المبيعات الهاتفية',
 outcome: 'المزيد من العملاء المحتملين المؤهلين، تحويل أعلى، خط أنابيب متوقع.',
 deliverables: ['حملات صادرة واتصال بارد', 'تأهيل العملاء المحتملين وتحديد المواعيد', 'تحديثات CRM وإدارة خط الأنابيب'],
 kpis: 'معدل التحويل، AOV، Lead-to-close',
 },
 {
 title: 'Back-Office',
 outcome: 'معالجة دقيقة، SLA صارم، عمليات قابلة للتوسع.',
 deliverables: ['إدخال البيانات ومعالجة المستندات', 'إدارة الطلبات والتنفيذ', 'تسوية الفواتير والمدفوعات'],
 kpis: 'الدقة، SLA، الإنتاجية',
 },
 {
 title: 'مراقبة المحتوى',
 outcome: 'TAT سريع، سياسات متسقة، تجربة مستخدم آمنة.',
 deliverables: ['مراجعة المحتوى المُنشأ من المستخدم', 'تطبيق الثقة والسلامة', 'معالجة التصعيدات والاستئنافات'],
 kpis: 'TAT، الدقة، معدل التصعيد',
 },
 {
 title: 'تطوير الويب',
 outcome: 'واجهة مستخدم متميزة، جاهز لـ SEO، بناء موجه للتحويل.',
 deliverables: ['تطبيقات ويب وصفحات هبوط مخصصة', 'منصات التجارة الإلكترونية والسوق', 'تطوير CMS ولوحة التحكم'],
 kpis: 'نتيجة Lighthouse، فهرسة SEO، التحويل',
 },
 {
 title: 'تطبيقات الموبايل',
 outcome: 'إصدارات مستقرة، UX نظيفة، احتفاظ قابل للقياس.',
 deliverables: ['تطبيقات iOS و Android أصلية/متعددة المنصات', 'تصميم UI/UX والنماذج الأولية', 'تحسين متجر التطبيقات والنشر'],
 kpis: 'الاحتفاظ، الجلسات بدون أعطال، وقت الإصدار',
 },
 {
 title: 'حلول الذكاء الاصطناعي',
 outcome: 'أتمتة، انحراف، وتقليل تكلفة الخدمة.',
 deliverables: ['روبوتات الدردشة والوكلاء الافتراضيون', 'أتمتة سير العمل و RPA', 'التحليلات التنبؤية ونماذج ML'],
 kpis: 'معدل الأتمتة، الانحراف، تكلفة الخدمة',
 }
 ],
 },
 },

 process: {
 en: {
 badge: 'Our Process',
 title: 'How We Deliver Excellence',
 subtitle: 'A proven methodology that minimizes risk and maximizes outcomes.',
 pilotCta: '7-Day Pilot',
 pilotSub: 'Start with a real pilot. See real results before you commit.',
 zeroRisk: 'Zero Risk',
 steps: [
 { title: 'Discover', duration: 'Week 1', description: 'Deep dive into your operations.', details: ['Goals & success metrics', 'Volumes & patterns', 'Languages & time zones', 'Tools & integrations'] },
 { title: 'Pilot', duration: '7 Days', description: 'Launch with a dedicated team.', details: ['Workflows & scripts', 'Agent onboarding', 'QA baseline setup', 'Real ticket handling'], highlight: true },
 { title: 'Ramp', duration: 'Week 2-4', description: 'Scale based on results.', details: ['Hiring & training', 'Shift scheduling', 'Capacity planning', 'Performance targets'] },
 { title: 'QA', duration: 'Ongoing', description: 'Continuous quality assurance.', details: ['Scorecards & rubrics', 'Weekly calibrations', 'Agent coaching', 'CSAT tracking'] },
 { title: 'Optimize', duration: 'Monthly', description: 'Data-driven improvements.', details: ['Knowledge base updates', 'Macros & templates', 'Automation rules', 'Process refinement'] },
 { title: 'Report', duration: 'Weekly', description: 'Transparent dashboards.', details: ['KPI dashboards', 'Executive summaries', 'Action plans', 'Business reviews'] }
 ],
 },
 fr: {
 badge: 'Notre Méthode',
 title: 'Comment Nous Livrons l\'Excellence',
 subtitle: 'Une méthodologie éprouvée qui minimise les risques et maximise les résultats.',
 pilotCta: 'Pilote 7 Jours',
 pilotSub: 'Commencez par un vrai pilote. Voyez de vrais résultats avant de vous engager.',
 zeroRisk: 'Zéro Risque',
 steps: [
 { title: 'Découverte', duration: 'Semaine 1', description: 'Analyse approfondie de vos opérations.', details: ['Objectifs & critères de succès', 'Volumes & patterns', 'Langues & fuseaux horaires', 'Outils & intégrations'] },
 { title: 'Pilote', duration: '7 Jours', description: 'Lancement avec équipe dédiée.', details: ['Workflows & scripts', 'Onboarding agents', 'Baseline QA', 'Traitement tickets réels'], highlight: true },
 { title: 'Montée en charge', duration: 'Semaine 2-4', description: 'Scaling basé sur résultats.', details: ['Recrutement & formation', 'Planning shifts', 'Planification capacité', 'Objectifs performance'] },
 { title: 'QA', duration: 'Continu', description: 'Assurance qualité continue.', details: ['Grilles & rubriques', 'Calibrations hebdo', 'Coaching agents', 'Suivi CSAT'] },
 { title: 'Optimisation', duration: 'Mensuel', description: 'Améliorations data-driven.', details: ['Mises à jour base connaissance', 'Macros & templates', 'Règles automation', 'Affinage process'] },
 { title: 'Reporting', duration: 'Hebdo', description: 'Dashboards transparents.', details: ['Dashboards KPI', 'Résumés exécutifs', 'Plans d\'action', 'Revues business'] }
 ],
 },
 es: {
 badge: 'Nuestro Proceso',
 title: 'Cómo Entregamos Excelencia',
 subtitle: 'Una metodología probada que minimiza riesgos y maximiza resultados.',
 pilotCta: 'Piloto 7 Días',
 pilotSub: 'Empieza con un piloto real. Ve resultados reales antes de comprometerte.',
 zeroRisk: 'Cero Riesgo',
 steps: [
 { title: 'Descubrir', duration: 'Semana 1', description: 'Análisis profundo de tus operaciones.', details: ['Objetivos & métricas de éxito', 'Volúmenes & patrones', 'Idiomas & zonas horarias', 'Herramientas & integraciones'] },
 { title: 'Piloto', duration: '7 Días', description: 'Lanzamiento con equipo dedicado.', details: ['Workflows & scripts', 'Onboarding agentes', 'Baseline QA', 'Manejo tickets reales'], highlight: true },
 { title: 'Rampa', duration: 'Semana 2-4', description: 'Escalar según resultados.', details: ['Contratación & formación', 'Programación turnos', 'Planificación capacidad', 'Objetivos rendimiento'] },
 { title: 'QA', duration: 'Continuo', description: 'Aseguramiento calidad continuo.', details: ['Scorecards & rúbricas', 'Calibraciones semanales', 'Coaching agentes', 'Seguimiento CSAT'] },
 { title: 'Optimizar', duration: 'Mensual', description: 'Mejoras basadas en datos.', details: ['Actualizaciones base conocimiento', 'Macros & plantillas', 'Reglas automatización', 'Refinamiento proceso'] },
 { title: 'Reportar', duration: 'Semanal', description: 'Dashboards transparentes.', details: ['Dashboards KPI', 'Resúmenes ejecutivos', 'Planes de acción', 'Revisiones negocio'] }
 ],
 },
 ar: {
 badge: 'عمليتنا',
 title: 'كيف نقدم التميز',
 subtitle: 'منهجية مثبتة تقلل المخاطر وتعظم النتائج.',
 pilotCta: 'تجربة 7 أيام',
 pilotSub: 'ابدأ بتجربة حقيقية. شاهد نتائج حقيقية قبل الالتزام.',
 zeroRisk: 'صفر مخاطر',
 steps: [
 { title: 'اكتشاف', duration: 'الأسبوع 1', description: 'تحليل عميق لعملياتك.', details: ['الأهداف ومعايير النجاح', 'الأحجام والأنماط', 'اللغات والمناطق الزمنية', 'الأدوات والتكاملات'] },
 { title: 'تجربة', duration: '7 أيام', description: 'إطلاق مع فريق مخصص.', details: ['سير العمل والنصوص', 'إعداد الوكلاء', 'خط أساس QA', 'التعامل مع التذاكر الحقيقية'], highlight: true },
 { title: 'توسيع', duration: 'الأسبوع 2-4', description: 'التوسع بناءً على النتائج.', details: ['التوظيف والتدريب', 'جدولة المناوبات', 'تخطيط القدرات', 'أهداف الأداء'] },
 { title: 'ضمان الجودة', duration: 'مستمر', description: 'ضمان جودة مستمر.', details: ['بطاقات الأداء والمعايير', 'المعايرات الأسبوعية', 'تدريب الوكلاء', 'تتبع CSAT'] },
 { title: 'تحسين', duration: 'شهري', description: 'تحسينات مدفوعة بالبيانات.', details: ['تحديثات قاعدة المعرفة', 'الماكرو والقوالب', 'قواعد الأتمتة', 'تحسين العملية'] },
 { title: 'التقارير', duration: 'أسبوعي', description: 'لوحات معلومات شفافة.', details: ['لوحات KPI', 'الملخصات التنفيذية', 'خطط العمل', 'مراجعات الأعمال'] }
 ],
 },
 },

 security: {
 en: {
 badge: 'Enterprise Security',
 title: 'Security & Compliance by Design',
 subtitle: 'Your data is our responsibility. We implement bank-grade security measures and maintain compliance with international standards.',
 items: [
 { title: 'Data Handling', description: 'Least privilege, controlled access, secure workflows' },
 { title: 'Access Controls', description: 'Role-based permissions + device policies' },
 { title: 'NDA & Confidentiality', description: 'Contractual guarantees + strict processes' },
 { title: 'Quality Monitoring', description: 'Regular quality reviews + weekly reporting' },
 { title: 'Data Protection', description: 'Privacy-first operations, data-protection framework configured per project' }
 ],
 certifications: ['', '', 'Data Protection', ],
 },
 fr: {
 badge: 'Sécurité Entreprise',
 title: 'Sécurité & Conformité dès la Conception',
 subtitle: 'Vos données sont notre responsabilité. Nous appliquons des mesures de sécurité bancaire et maintenons la conformité avec les standards internationaux.',
 items: [
 { title: 'Données', description: 'Accès minimaux, workflows sécurisés' },
 { title: 'Contrôles', description: 'Rôles, permissions, politiques appareils' },
 { title: 'NDA', description: 'Confidentialité contractuelle + process stricts' },
 { title: 'Qualité', description: 'QA quotidien + reporting hebdo' },
 { title: 'Protection des données', description: 'Principes privacy-first, cadre de protection des données configuré par projet' }
 ],
 certifications: ['', '', 'Protection des données', ],
 },
 es: {
 badge: 'Seguridad Empresarial',
 title: 'Seguridad & Cumplimiento por Diseño',
 subtitle: 'Tus datos son nuestra responsabilidad. Implementamos medidas de seguridad de nivel bancario y mantenemos cumplimiento con estándares internacionales.',
 items: [
 { title: 'Manejo de Datos', description: 'Privilegio mínimo, acceso controlado, workflows seguros' },
 { title: 'Controles de Acceso', description: 'Permisos basados en roles + políticas de dispositivos' },
 { title: 'NDA & Confidencialidad', description: 'Garantías contractuales + procesos estrictos' },
 { title: 'Monitoreo de Calidad', description: 'QA diario + reportes semanales' },
 { title: 'Protección de datos', description: 'Operaciones privacy-first, marco de protección de datos configurado por proyecto' }
 ],
 certifications: ['', '', 'Protección de datos', ],
 },
 ar: {
 badge: 'أمان المؤسسات',
 title: 'الأمان والامتثال حسب التصميم',
 subtitle: 'بياناتك مسؤوليتنا. نطبق إجراءات أمان على مستوى البنوك ونحافظ على الامتثال للمعايير الدولية.',
 items: [
 { title: 'معالجة البيانات', description: 'صلاحيات محدودة، وصول مُتحكم، سير عمل آمن' },
 { title: 'ضوابط الوصول', description: 'صلاحيات قائمة على الأدوار + سياسات الأجهزة' },
 { title: 'NDA والسرية', description: 'ضمانات تعاقدية + عمليات صارمة' },
 { title: 'مراقبة الجودة', description: 'QA يومي + تقارير أسبوعية' },
 { title: 'حماية البيانات', description: 'عمليات تعطي الأولوية للخصوصية، إطار حماية البيانات يُكوَّن حسب كل مشروع' }
 ],
 certifications: ['', '', 'حماية البيانات', ],
 },
 },

 finalCta: {
 en: {
 title: 'Ready to Scale Support, Sales, or Delivery—Fast?',
 subtitle: 'Tell us your volumes and languages. We\'ll propose a pilot plan within 48 hours.',
 cta1: 'Book a Call',
 cta2: 'Get a Quote',
 bookCard: {
 title: 'Book a Discovery Call',
 description: '30-minute call to discuss your needs, explore solutions, and get a custom quote.',
 cta: 'Schedule Now',
 },
 whatsappCard: {
 title: 'Chat on WhatsApp',
 description: 'Quick questions? Get instant answers from our team via WhatsApp.',
 cta: 'Start Chat',
 },
 formTitle: 'Quick Contact',
 formFields: {
 name: 'Name',
 namePlaceholder: 'Your name',
 email: 'Email',
 emailPlaceholder: 'your@email.com',
 service: 'Service',
 servicePlaceholder: 'Select service',
 languages: 'Languages Needed',
 languagesPlaceholder: 'Select languages',
 message: 'Message',
 messagePlaceholder: 'Tell us about your project...',
 submit: 'Send Message',
 },
 },
 fr: {
 title: 'Prêt à scaler votre Support, votre Vente ou votre Delivery — rapidement ?',
 subtitle: 'Donnez vos volumes et langues. On vous propose un plan pilote sous 48h.',
 cta1: 'Réserver un appel',
 cta2: 'Demander un devis',
 bookCard: {
 title: 'Réserver un appel de découverte',
 description: 'Appel de 30 minutes pour discuter de vos besoins, explorer les solutions et obtenir un devis personnalisé.',
 cta: 'Planifier maintenant',
 },
 whatsappCard: {
 title: 'Discuter sur WhatsApp',
 description: 'Questions rapides ? Obtenez des réponses instantanées de notre équipe via WhatsApp.',
 cta: 'Démarrer le chat',
 },
 formTitle: 'Contact Rapide',
 formFields: {
 name: 'Nom',
 namePlaceholder: 'Votre nom',
 email: 'Email',
 emailPlaceholder: 'votre@email.com',
 service: 'Service',
 servicePlaceholder: 'Sélectionner un service',
 languages: 'Langues Nécessaires',
 languagesPlaceholder: 'Sélectionner les langues',
 message: 'Message',
 messagePlaceholder: 'Parlez-nous de votre projet...',
 submit: 'Envoyer le message',
 },
 },
 es: {
 title: '¿Listo para escalar soporte, ventas o delivery—rápido?',
 subtitle: 'Dinos volumen e idiomas. Te proponemos un plan de piloto en 48h.',
 cta1: 'Reservar una llamada',
 cta2: 'Solicitar presupuesto',
 bookCard: {
 title: 'Reservar una llamada de descubrimiento',
 description: 'Llamada de 30 minutos para discutir tus necesidades, explorar soluciones y obtener un presupuesto personalizado.',
 cta: 'Agendar ahora',
 },
 whatsappCard: {
 title: 'Chatea en WhatsApp',
 description: '¿Preguntas rápidas? Obtén respuestas instantáneas de nuestro equipo vía WhatsApp.',
 cta: 'Iniciar chat',
 },
 formTitle: 'Contacto Rápido',
 formFields: {
 name: 'Nombre',
 namePlaceholder: 'Tu nombre',
 email: 'Email',
 emailPlaceholder: 'tu@email.com',
 service: 'Servicio',
 servicePlaceholder: 'Seleccionar servicio',
 languages: 'Idiomas Necesarios',
 languagesPlaceholder: 'Seleccionar idiomas',
 message: 'Mensaje',
 messagePlaceholder: 'Cuéntanos sobre tu proyecto...',
 submit: 'Enviar mensaje',
 },
 },
 ar: {
 title: 'جاهز لتوسيع الدعم أو المبيعات أو التسليم بسرعة؟',
 subtitle: 'أخبرنا بالحجم واللغات، ونقترح خطة تجربة خلال 48 ساعة.',
 cta1: 'احجز مكالمة',
 cta2: 'اطلب عرض سعر',
 bookCard: {
 title: 'احجز مكالمة استكشافية',
 description: 'مكالمة 30 دقيقة لمناقشة احتياجاتك، واستكشاف الحلول، والحصول على عرض أسعار مخصص.',
 cta: 'جدول الآن',
 },
 whatsappCard: {
 title: 'الدردشة عبر واتساب',
 description: 'أسئلة سريعة؟ احصل على إجابات فورية من فريقنا عبر واتساب.',
 cta: 'بدء الدردشة',
 },
 formTitle: 'اتصال سريع',
 formFields: {
 name: 'الاسم',
 namePlaceholder: 'اسمك',
 email: 'البريد الإلكتروني',
 emailPlaceholder: 'بريدك@email.com',
 service: 'الخدمة',
 servicePlaceholder: 'اختر خدمة',
 languages: 'اللغات المطلوبة',
 languagesPlaceholder: 'اختر اللغات',
 message: 'الرسالة',
 messagePlaceholder: 'أخبرنا عن مشروعك...',
 submit: 'إرسال الرسالة',
 },
 },
 },

 faq: {
 en: {
 badge: 'FAQ',
 title: 'Frequently Asked Questions',
 subtitle: 'Everything you need to know about partnering with BPO Contact.',
 items: [
 { q: 'How fast can you start?', a: 'We can launch a pilot in 7 days. A rollout plan is shared within 24–48h after the discovery call.' },
 { q: 'Which languages do you cover?', a: 'EN/FR/ES/AR plus additional languages depending on your needs and volume.' },
 { q: 'Do you operate 24/7?', a: '24/7 coverage is available on request, with schedules and escalation rules defined together.' },
 { q: 'What tools do you integrate with?', a: 'Zendesk, Freshdesk, Salesforce, HubSpot, Intercom, Jira, and custom stacks.' },
 { q: 'How do you ensure quality?', a: 'Regular quality reviews, calibrations, weekly reporting, and continuous improvement plans.' },
 { q: 'How do you price?', a: 'Per hour, per ticket, per lead, or hybrid—depending on scope and SLAs.' },
 { q: 'Can we start with a pilot?', a: 'Yes. A pilot validates KPIs, workflows, and scaling before full ramp.' },
 { q: 'How do you handle data security?', a: 'NDA, least-privilege access, device policies, and secure processes.' }
 ],
 },
 fr: {
 badge: 'FAQ',
 title: 'Questions Fréquentes',
 subtitle: 'Tout ce que vous devez savoir pour devenir partenaire BPO Contact.',
 items: [
 { q: 'À quelle vitesse pouvez-vous démarrer ?', a: 'Pilote possible en 7 jours. Plan de déploiement communiqué sous 24–48h après l\'appel.' },
 { q: 'Quelles langues couvrez-vous ?', a: 'FR/EN/ES/AR + d\'autres selon vos besoins et volumes.' },
 { q: 'Faites-vous du 24/7?', a: 'Couverture 24/7 possible sur demande, avec planning et règles d\'escalade définis ensemble.' },
 { q: 'Avec quels outils vous intégrez-vous ?', a: 'Zendesk, Freshdesk, Salesforce, HubSpot, Intercom, Jira, etc.' },
 { q: 'Comment garantissez-vous la qualité ?', a: 'QA quotidien, calibrations, reporting hebdo, plans d\'amélioration.' },
 { q: 'Quels sont vos modèles de pricing ?', a: 'À l\'heure, au ticket, au lead, ou hybride selon scope et SLA.' },
 { q: 'Peut-on commencer par un pilote ?', a: 'Oui, pour valider KPIs, process et montée en charge.' },
 { q: 'Sécurité des données ?', a: 'NDA, accès minimaux, politiques appareils, process sécurisés.' }
 ],
 },
 es: {
 badge: 'FAQ',
 title: 'Preguntas Frecuentes',
 subtitle: 'Todo lo que necesitas saber para asociarte con BPO Contact.',
 items: [
 { q: '¿Qué tan rápido pueden empezar?', a: 'Podemos lanzar un piloto en 7 días. Plan en 24–48h tras la llamada.' },
 { q: '¿Qué idiomas cubren?', a: 'ES/EN/FR/AR + otros según volumen.' },
 { q: '¿Trabajan 24/7?', a: 'Cobertura 24/7 disponible a petición, con escalados definidos.' },
 { q: '¿Con qué herramientas integran?', a: 'Zendesk, Freshdesk, Salesforce, HubSpot, Intercom, Jira, etc.' },
 { q: '¿Cómo aseguran la calidad?', a: 'QA diario, calibraciones y reportes semanales.' },
 { q: '¿Cómo es el pricing?', a: 'Por hora, por ticket, por lead o híbrido.' },
 { q: '¿Podemos empezar con piloto?', a: 'Sí, para validar KPIs y escalar.' },
 { q: '¿Seguridad de datos?', a: 'NDA, accesos mínimos, políticas de dispositivos y procesos seguros.' }
 ],
 },
 ar: {
 badge: 'الأسئلة الشائعة',
 title: 'الأسئلة المتكررة',
 subtitle: 'كل ما تحتاج معرفته للشراكة مع BPO Contact.',
 items: [
 { q: 'متى يمكنكم البدء؟', a: 'يمكننا إطلاق تجربة خلال 7 أيام، وخطة التنفيذ خلال 48 ساعة بعد مكالمة الاكتشاف.' },
 { q: 'ما اللغات المتاحة؟', a: 'العربية/الفرنسية/الإنجليزية/الإسبانية + لغات إضافية حسب الحاجة.' },
 { q: 'هل تعملون 24/7؟', a: 'تغطية 24/7 متاحة عند الطلب، مع قواعد تصعيد واضحة.' },
 { q: 'ما الأدوات التي تتكاملون معها؟', a: 'Zendesk وFreshdesk وSalesforce وHubSpot وIntercom وJira وغيرها.' },
 { q: 'كيف تضمنون الجودة؟', a: 'QA يومي، معايرات، وتقارير أسبوعية مع تحسين مستمر.' },
 { q: 'كيف يكون التسعير؟', a: 'بالساعة أو بالتذكرة أو بالـLead أو نموذج هجين.' },
 { q: 'هل يمكن البدء بتجربة؟', a: 'نعم، لتأكيد KPIs والعمليات قبل التوسع.' },
 { q: 'كيف تتعاملون مع أمان البيانات؟', a: 'NDA، صلاحيات وصول محدودة، سياسات أجهزة، وعمليات آمنة.' }
 ],
 },
 },
};

export function getHomeContent<T extends keyof typeof homeContent>(
 section: T,
 lang: string
): (typeof homeContent)[T]['en'] {
 const sectionData = homeContent[section] as Record<string, (typeof homeContent)[T]['en']>;
 if (sectionData[lang]) {
 return sectionData[lang];
 }
 return sectionData['en'];
}
